import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1154165c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "date-paginator" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-left" }, null, -1))
const _hoisted_3 = { class: "pagination pagination--date-display" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi pi-angle-right" }, null, -1))

import { computed } from 'vue'
import moment from 'moment'
import { useStore } from 'vuex'
import Button from 'primevue/button'
import Typography from '@/components/Rain/Typography/Typography.vue'

interface Props {
    loading: boolean
    hasNext: boolean
    hasPrev: boolean
    selectedDate: string // Format: ISO 8601 YYYY-MM-DD
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HuddlesDatePaginator',
  props: {
    loading: { type: Boolean, default: false },
    hasNext: { type: Boolean },
    hasPrev: { type: Boolean },
    selectedDate: {}
  },
  emits: ['onPaginate'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const store = useStore()
const emit = __emit

const formattedDate = computed(() =>
    moment(props.selectedDate).format('dddd D MMMM')
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Button), {
      class: "pagination pagination--button",
      disabled: !_ctx.hasPrev || _ctx.loading,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('onPaginate', 'previous')))
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(Typography, { variant: "subtitle2" }, {
          default: _withCtx(() => [
            _createTextVNode("Previous day")
          ], undefined, true),
          _: 1
        })
      ], undefined, true),
      _: 1
    }, 8, ["disabled"]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(Typography, { variant: "subtitle2" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(formattedDate.value), 1)
        ], undefined, true),
        _: 1
      })
    ]),
    _createVNode(_unref(Button), {
      class: "pagination pagination--button",
      disabled: !_ctx.hasNext || _ctx.loading,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('onPaginate', 'next')))
    }, {
      default: _withCtx(() => [
        _createVNode(Typography, { variant: "subtitle2" }, {
          default: _withCtx(() => [
            _createTextVNode("Next day")
          ], undefined, true),
          _: 1
        }),
        _hoisted_5
      ], undefined, true),
      _: 1
    }, 8, ["disabled"])
  ]))
}
}

})